module.exports = __webpack_public_path__ + "img/category-popular-hover.42cb8d26.png";